import { FilterDropdown } from "@repo/ui";

import type { DropDownProps } from ".";

interface Props extends DropDownProps {}

export function RegionsDropdown(props: Props) {
	return (
		<FilterDropdown
			{...props}
			id="companyRegionIds"
			values={props.options?.data ?? []}
			objectName="Regions"
			label={props.label ?? "Region"}
			fullLength
			isMulti
		/>
	);
}
